import React from 'react';
import Helmet from 'react-helmet';
import get from 'lodash/get';

const MetaTags = props => {
  const pageTitle = get(props, 'fields.MetaTitle.value', 'Page');
  const metaContent = get(props, 'fields.MetaDescription.value');
  const canonicalUrl = get(props, 'fields.canonicalUrl.value');
  return (
    <Helmet>
      <title>{pageTitle}</title>
      {Boolean(metaContent) && (
        <meta name="description" content={metaContent} />
      )}
      {Boolean(canonicalUrl) && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  );
};

export default MetaTags;
